module.exports = __webpack_public_path__ + "img/green-3-oval-solid.d8446cc5.svg";